import React from 'react';
import {get} from 'lodash';

import Graph from './Graph';

export default function ({dataCategory}) {

    if (dataCategory === undefined) {
        return (
            <div className="flex-2">
            </div>
        );
    } else {
        const n = get(dataCategory, 'categories', []).length;
        if (n == 0) {
            return null;
        }
    }

    return (
        <div className="flex-2">
            <Graph
                dataCategory={dataCategory}
            />
        </div>
    );
}
